<template>
    <div class="slideshow">
        <VueSlickCarousel
            :centerMode="true"
            :adaptiveHeight="true"
            :infinite="true"
            :autoplay="true"
            :centerPadding="'0'"
            :pauseOnHover="false"
            :arrows="false"
            :autoplaySpeed="autoplayTimeout * 1000">
            <div v-for="(slide, slideIndex) in items" :key="slideIndex" class="slide">
                <img :alt="'slide' + slideIndex" :src="slide"/>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    name: 'Slideshow',
    components: { VueSlickCarousel },
    props: {
        items: Array,
        music: String,
        autoplayTimeout: Number,
    },
    data() {
        return {
            audio: null,
        }
    },
    methods: {
        closeSlideshow() {
            this.$inertia.visit(this.route('terminal.lobby'));
        },
        addCloseSlideshowEventListeners() {
            ['keydown','touchstart','click'].forEach(event => {
                window.addEventListener(event , this.closeSlideshow);
            });
        },
        removeCloseSlideshowEventListeners() {
            ['keydown','touchstart','click'].forEach(event => {
                window.removeEventListener(event, this.closeSlideshow);
            });
        },
    },
    created() {
        this.addCloseSlideshowEventListeners();

        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('BalanceChanged', (e) => {
                if (e.balance > 0) {
                    this.closeSlideshow();
                }
            });
    },
    mounted() {
        if (this.music !== null) {
            this.audio = new Audio(this.music);
            this.audio.loop = true;
            this.audio.play();
        }
    },
    beforeDestroy() {
        this.removeCloseSlideshowEventListeners();

        if (this.music !== null) {
            this.audio.pause();
            this.audio.currentTime = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
    .slideshow {
        .slide {
            width: 100vw;
            height: calc(100vh - 64px);
            display: flex !important;
            align-items: center;
            justify-content: center;

            img {
                object-fit: contain;
                margin: 0 auto;
                display: block;
            }
        }
    }
</style>
